module.exports = __webpack_public_path__ + "static/Tesco-07e8b3ca041158ed3d369687526702a7.webp";